// Standard library imports
import React, { useState, useEffect } from 'react';

// External library import
import { UilFileDownload, UilTimesCircle } from '@iconscout/react-unicons';
import { toast } from 'react-toastify';

// Internal module imports
import Typography from '../../../../components/Typography/Typography';
import { useLoader } from '../../../../hooks';
import Table from '../../../../components/Table/Table';
import { momentTimeFormater } from '../../../../utils/timeHelper';


// CSS Imports
import classes from '../../../Edge/EdgeError/EdgeError.module.css';
import bidClasses from '../../../../styles/Bids.module.css';
import { IncidentsServiceRoot } from '../../../../services/EdgeIncidentService';
import CustomTooltip from '../../../../components/CustomToolTip/CustomTooltip';

const EdgeIncidentFileUploadHistory = ({ incidentId, getEdgeIncidents }) => {
    const [startLoader, stopLoader] = useLoader();
    const [totalCount, setTotalCount] = useState(0);

    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        getUploadedFilesHistory();
    }, [incidentId]);

    const getUploadedFilesHistory = () => {
        if (incidentId) {
            IncidentsServiceRoot.GetUploadedFilesHistory(incidentId, startLoader, handleUploadedFileHistorySuccess, handleError, stopLoader);
        }
    };

    const handleError = (err) => {
        if (err && err.response) toast.error(err.response.data.message);
    };

    const handleGetSignedUrl = (key) => {
        IncidentsServiceRoot.GetUploadedFileSignedURL({ key, type: 'edgeFile' }, startLoader, handleFileSignedURLSuccess, handleError, stopLoader);
    };

    const handleFileSignedURLSuccess = ({ data }) => {
        if (data.data?.signedUrl) {
            window.open(data.data.signedUrl, '_blank');
        }
    };

    const handleUploadedFileHistorySuccess = (data) => {
        const items = data.data.data || [];
        const processedData = items.map((item, index) => {
            return {
                slNo: index + 1,
                name: item.name.length > 35 ? <CustomTooltip content={item.name}>{item.name.substring(0, 35) + '...'}</CustomTooltip> : item.name || '--',
                createdAt: item.createdAt ? momentTimeFormater(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : '--',
                action: (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <CustomTooltip content={'Download file'}>
                            <UilFileDownload size={'1.2vw'} style={{ color: 'var(--color-primary)' }} onClick={() => handleGetSignedUrl(item.key)} />
                        </CustomTooltip>
                        <CustomTooltip content={'Delete file'}>
                            <UilTimesCircle style={{ color: 'var(--color-primary)' }} size={'1.3vw'} onClick={() => removeFile(item.key, item._id)} />
                        </CustomTooltip>
                    </div>
                ),
            };
        });
        setTableData(processedData);
        setTotalCount(processedData.length);
    };

    const removeFile = (key, id) => {
        IncidentsServiceRoot.RemoveIncidentUploadFile(id, incidentId, startLoader, handleRemoveFileSuccess, handleError, stopLoader);  
    };

    const handleRemoveFileSuccess = () => {
        getUploadedFilesHistory();
        getEdgeIncidents();
        toast.success('File removed successfully');
    };

    return (
        <div className={bidClasses.Bids}>
            <div className={classes.Header}>
                <div className={classes.ErrorDropdownContainer}>
                    <Typography content={'Incident Uploaded Files History'} />
                    <div className={bidClasses.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={totalCount || 0} />
                        </span>
                    </div>
                </div>
            </div>

            <div>
                <Table head={['Sl.No', 'File Name', 'CREATED AT (CET)', 'ACTION']} keys={['slNo', 'name', 'createdAt', 'action']} data={tableData} />
            </div>
        </div>
    );
};

export default EdgeIncidentFileUploadHistory;
